var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileCurveMask = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 375,
  height: 429,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0c71e7",
  d: "M375 429H0V12s52 176.884 187.5 176.884H375V429Z"
})));
export { SvgMobileCurveMask as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzc1IiBoZWlnaHQ9IjQyOSIgdmlld0JveD0iMCAwIDM3NSA0MjkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMzc1IDQyOUwtMy4wNTE3NmUtMDUgNDI5TDUuOTM3NzJlLTA2IDEyQzUuOTM3NzJlLTA2IDEyIDUyIDE4OC44ODQgMTg3LjUgMTg4Ljg4NEMzMjMgMTg4Ljg4NCAzNzUgMTg4Ljg4NCAzNzUgMTg4Ljg4NEwzNzUgNDI5WiIgZmlsbD0iIzBjNzFlNyIvPgo8L3N2Zz4K";